export class AriaToggling {
    showClass: string = 'show-menu';
    mNav: string = '#mainNav';
    constructor(public links) {
        //Keyboard Navigation
        if (window.innerWidth > 1025 && !document.getElementsByTagName('html')[0].classList.contains('mod-touchevents')) {
            if (window["element"] && !Element.prototype["closest"]) {
                Element.prototype["closest"] =
                    function (s) {
                        var matches = (this.document || this.ownerdocument).queryselectorall(s),
                            i,
                            el = this;
                        do {
                            i = matches.length;
                            while (--i >= 0 && matches.item(i) !== el) { };
                        } while ((i < 0) && (el = el.parentelement));
                        return el;
                    };
            }
            links.forEach((link) => {
                let linkParent = link.parentNode;
                link.addEventListener('focus', (e) => {
                    this.focusOn(e,link,linkParent);
                });
                link.addEventListener('blur', (e) => {
                    this.blurOut(e, linkParent);
                });
            });
        }
        //Tablet landscape view to allow users to tap a parent link to see the children.
        if (window.innerWidth <= 1600 && window.innerWidth > 767 && document.getElementsByTagName('html')[0].classList.contains('mod-touchevents')) {
            //Click outside of the header
            this.outSideClicks();
            links.forEach((link) => { 
                let linkParent = link.parentNode;
                link.addEventListener('click', (e) => {
                    if (!linkParent.classList.contains(this.showClass)) {
                        e.preventDefault();
                        if (document.querySelector('.'+this.showClass) !== null) {
                            document.querySelector('.' + this.showClass).classList.remove(this.showClass);
                        }
                        linkParent.classList.add(this.showClass);
                    }
                });
            });
        }
    }
    outSideClicks() {
        let mNav = document.querySelector(this.mNav);
        if (mNav) {
            // For clicks inside the element
            document.querySelector(this.mNav).addEventListener('click', (e) => {
                this.checkClick(e);
            });
            // For clicks elsewhere on the page
            document.addEventListener('click', () => {
                //close stuff
                if (document.querySelector('.' + this.showClass) !== null) {
                    document.querySelector('.' + this.showClass).classList.remove(this.showClass);
                }
            });
            // For clicks elsewhere on the page
            document.addEventListener('touchstart', () => {
                //close stuff
                if (document.querySelector('.' + this.showClass) !== null) {
                    document.querySelector('.' + this.showClass).classList.remove(this.showClass);
                }
            });
        }
    }
    checkClick(e) {
        // Make sure the event doesn't bubble from your element
        if (e) { e.stopPropagation(); }
        else { window.event.cancelBubble = true; }
    }
    focusOn(e,link,linkParent) {
        setTimeout(() => {
            this.toggleOff();
            if (link.classList.contains('has-meganav-js') && !linkParent.classList.contains(this.showClass)) {
                this.toggleOn(linkParent);
            }
            e.stopPropagation();
            var viewableLinks = Array.prototype.slice.call(linkParent.querySelectorAll('[aria-hidden="false"] a'));
            if (viewableLinks.length > 0) {
                viewableLinks.forEach((viewableLink) => {
                    viewableLink.addEventListener('blur', (e) => {
                        this.blurOut(e, linkParent);
                    });
                });
            }
        }, 10);
    }
    toggleOn(linkParent) {
        linkParent.classList.add(this.showClass);
        linkParent.querySelector('[aria-hidden="true"]').setAttribute('aria-hidden', 'false');
    }
    blurOut(e, linkParent) {
        setTimeout(() => {
            if (document.activeElement["closest"]('[aria-haspopup="true"]') !== linkParent || document.activeElement["closest"]('[aria-haspopup="true"]') === null) {
                this.toggleOff();
            }
            e.stopPropagation();
        }, 10);
    }
    toggleOff() {
        var items = Array.prototype.slice.call(document.querySelectorAll('.nav-main-list-item.show-menu'));
        if (items.length > 0) {
            items.forEach(function (item) {
                item.classList.remove('show-menu');
                item.querySelector('[aria-hidden="false"]').setAttribute('aria-hidden', 'true');
            });
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/aria-click-toggling.ts